import { Box } from "@mui/material";
import React, { memo } from "react";
import { EVoucherStatus } from "../EVoucherList.const";

export const VoucherStatus = memo(function VoucherStatus(props) {
  const { params } = props;

  const statusToColor = {
    [EVoucherStatus.AC]: "green",
    [EVoucherStatus.SU]: "orange",
    [EVoucherStatus.BL]: "red",
    [EVoucherStatus.RF]: "red",
  };
  const color = statusToColor[params.row.voucherStatus] || "gray";
  return <Box sx={{ color }}>{params.row.voucherStatusName}</Box>;
});
